import { useMutation, useQueryClient } from 'react-query';

import type { IStandardErrorResponse } from 'src/api/common';
import { useNotifications } from 'src/notifications';
import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';
import type { IShowing } from 'src/api/landlord-showings-api';

type ISetTourAttendanceResponse = {
    tour: IShowing;
};

export type ISetTourAttendancePayload = {
    tourId: number;
    isAttended: boolean | null;
};

export const useSetShowingStatus = () => {
    const queryClient = useQueryClient();
    const { addNotification } = useNotifications();

    return useMutation<IShowing, IStandardErrorResponse, ISetTourAttendancePayload>(
        async (payload) => {
            const res = await apiClient(`api/landlord/showings/${payload.tourId}/attendance`, {
                method: 'post',
                json: {
                    is_attended: payload.isAttended,
                },
            }).json<ISetTourAttendanceResponse>();
            return res.tour;
        },
        {
            onSuccess: () => {
                addNotification('Tour updated', 'success');
                queryClient.invalidateQueries(queryKeys.showings);
            },
            onError: (error) => {
                const errorMessage = error.msg || 'Failed to update tour';
                addNotification(errorMessage, 'error');
            },
        },
    );
};
